import { Link } from "react-router-dom";
import { mangaCategories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="container-site grid grid-cols-1 gap-10 py-12 md:grid-cols-2 lg:grid-cols-4 md:py-16">
        <div>
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              89890<span className="text-primary-400">漫画网</span>
            </span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-background-400">
            专注浪漫恋爱题材的漫画在线阅读平台，免费提供高清连载与完结大结局畅读服务，让每一位读者都能沉浸于甜蜜的故事世界。
          </p>
          <div className="mt-4 flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100/10 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-wechat-line" aria-hidden="true" />
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100/10 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-weibo-line" aria-hidden="true" />
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100/10 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-douban-line" aria-hidden="true" />
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-100/10 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-bilibili-line" aria-hidden="true" />
            </span>
          </div>
        </div>

        <nav aria-label="分类导航">
          <h4 className="font-heading text-sm font-bold text-background-50">热门分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {mangaCategories.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="inline-flex items-center gap-1.5 text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-xs" aria-hidden="true" />
                  {c.name}漫画
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="平台导航">
          <h4 className="font-heading text-sm font-bold text-background-50">平台导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/" className="inline-flex items-center gap-1.5 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-home-4-line text-xs" aria-hidden="true" />
                网站首页
              </Link>
            </li>
            <li>
              <Link to="/category/complete" className="inline-flex items-center gap-1.5 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-flag-2-line text-xs" aria-hidden="true" />
                完结大结局
              </Link>
            </li>
            <li>
              <Link to="/category/sweet" className="inline-flex items-center gap-1.5 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-heart-3-line text-xs" aria-hidden="true" />
                高甜推荐
              </Link>
            </li>
            <li>
              <Link to="/about" className="inline-flex items-center gap-1.5 text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-question-line text-xs" aria-hidden="true" />
                关于我们
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">联系我们</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-400">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5" aria-hidden="true" />
              <span>service@89890manhua.com</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-customer-service-2-line mt-0.5" aria-hidden="true" />
              <span>在线客服：每日 9:00-23:00</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5" aria-hidden="true" />
              <span>中国 · 上海市静安区南京西路898号</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="container-site flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-500 sm:flex-row">
          <p>© 2018-2026 89890漫画网 版权所有 · 免费高清漫画在线阅读平台</p>
          <p className="flex items-center gap-1">
            <i className="ri-shield-check-line" aria-hidden="true" />
            健康阅读 · 拒绝盗版 · 支持正版漫画
          </p>
        </div>
      </div>
    </footer>
  );
}